export const queryKeys = {
  player: (userId: number) => ['player', userId] as const,
  playerSkills: (userId: number) => ['player', userId, 'skills'] as const,
  playerPantsu: (userId: number) => ['player', userId, 'pantsu'] as const,
  autobuy: (userId: number) => ['player', userId, 'autobuy'] as const,
  waifus: (userId: number) => ['waifus', userId] as const,
  waifu: (waifuId: number) => ['waifu', waifuId] as const,
  waifuEquipment: (waifuId: number, userId: number | undefined) =>
    ['waifu', waifuId, 'equipment', userId] as const,
  waifusForItem: (userId: number, itemId: string) =>
    ['inventory', userId, 'waifus-for-item', itemId] as const,
  itemCount: (userId: number, itemId: string) =>
    ['inventory', userId, 'item', itemId, 'count'] as const,
  inventory: (userId: number) => ['inventory', userId] as const,
  shop: (userId: number) => ['shop', userId] as const,
  shopCheck: (userId: number) => ['shop', userId, 'check'] as const,
  shopConsumables: () => ['shop', 'consumables'] as const,
  events: (userId: number) => ['events', userId, 'recent'] as const,
  eventsArchive: (userId: number, page: number) =>
    ['events', userId, 'archive', page] as const,
  mapLocations: () => ['map', 'locations'] as const,
  mapPositions: () => ['map', 'positions'] as const,
  explored: (userId: number) => ['explored', userId] as const,
  skills: () => ['skills'] as const,
  reference: () => ['reference', 'waifu'] as const,
  relationships: (userId: number) => ['relationships', userId] as const,
  allPantsu: () => ['pantsu', 'all'] as const,
  levelTable: () => ['level-table'] as const,
  weaponTiers: () => ['weapon-tiers'] as const,
  armorTiers: () => ['armor-tiers'] as const,
  items: () => ['items'] as const,
};
